var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import classnames from "classnames";
import { ScrollableGrid, utils, Input } from "zebulon-controls";
import { cellData } from "./utils/compute.data";
export var Rows = function (_ScrollableGrid) {
  _inherits(Rows, _ScrollableGrid);

  function Rows() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Rows);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rows.__proto__ || Object.getPrototypeOf(Rows)).call.apply(_ref, [this].concat(args))), _this), _this.cell = function (tableEditable, row, column, status, data, params, style, focused, hasFocus, selected, onMouseDown, onMouseUp, onMouseOver, onChange, onFocus, rowIndex, onDoubleClick, component) {
      var _cellData = cellData(row, column, status, data, params, focused),
          editable = _cellData.editable,
          value = _cellData.value,
          select = _cellData.select;

      var className = classnames({
        "zebulon-table-cell": true,
        "zebulon-table-cell-odd": rowIndex % 2 === 1,
        "zebulon-table-cell-selected": selected,
        "zebulon-table-cell-focused": focused,
        "zebulon-table-cell-editable": editable && focused
      });
      var id = "cell: " + component + "-" + row.index_ + "-" + column.index_;
      return React.createElement(Input, {
        row: row,
        column: column,
        style: style,
        className: className,
        value: value,
        editable: editable && tableEditable,
        focused: focused,
        hasFocus: hasFocus,
        select: select,
        id: id,
        key: id,
        onChange: onChange,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onDoubleClick: onDoubleClick ? function (e) {
          return onDoubleClick(e, row, column);
        } : function () {},
        menu: "cell-menu",
        component: component,
        ref: function ref(_ref2) {
          if (focused && hasFocus) {
            _this.focused = _ref2;
          }
        }
      });
    }, _this.rowRenderer = function (tableEditable, row, status, meta, startIndex, shift, visibleWidth, rowHeight, rowIndex, hasFocus, component) {
      var cells = [];
      var left = shift,
          index = startIndex;
      var selectedRange = _this.selectedRange();
      while (index < meta.length && left < visibleWidth) {
        var column = meta[index];
        if (!column.hidden) {
          (function () {
            var textAlign = column.alignement || "left";
            if (!column.alignement) {
              if (column.dataType === "number") {
                textAlign = "right";
              } else if (column.dataType === "date" || column.dataType === "boolean") {
                textAlign = "center";
              }
            }
            var columnIndex = index;
            var selected = utils.isInRange({ columns: index, rows: rowIndex }, selectedRange.start, selectedRange.end),
                focused = selectedRange.end.rows === rowIndex && selectedRange.end.columns === index,
                onMouseDown = function onMouseDown(e) {
              e.preventDefault();
              _this.selectCell({ rows: rowIndex, columns: columnIndex }, e.shiftKey);
            },
                onMouseOver = function onMouseOver(e) {
              if ((e.buttons & 1) === 1 && !_this.noOver) {
                e.preventDefault();
                _this.selectCell({ rows: rowIndex, columns: columnIndex }, true);
              }
            },
                onMouseUp = function onMouseUp(e) {
              e.preventDefault();
              _this.mouseDown = false;
            };
            cells.push(_this.cell(tableEditable, row, column, status, _this.props.data, _this.props.params, {
              position: "absolute",
              left: left,
              width: Math.min(false ? column.computedWidth + shift : column.computedWidth, visibleWidth - left),
              height: rowHeight,
              textAlign: textAlign
            }, focused, hasFocus && focused, selected, onMouseDown, onMouseUp, onMouseOver, _this.props.onChange, _this.props.onFocus, rowIndex, _this.props.onDoubleClick, component));
            left += column.computedWidth;
          })();
        }
        index += 1;
      }
      return React.createElement(
        "div",
        {
          key: rowIndex,
          id: rowIndex,
          style: {
            display: "flex",
            height: rowHeight
          }
        },
        cells
      );
    }, _this.getContent = function () {
      _this.noOver = true;
      var items = [];
      var _this$props = _this.props,
          data = _this$props.data,
          meta = _this$props.meta,
          height = _this$props.height,
          rowHeight = _this$props.rowHeight,
          width = _this$props.width,
          updatedRows = _this$props.updatedRows,
          hasFocus = _this$props.hasFocus,
          component = _this$props.component;

      var i = 0,
          index = _this.props.scroll.rows.startIndex,
          indexPage = 0,
          rows = data,
          columnStartIndex = _this.props.scroll.columns.startIndex,
          columnShift = _this.props.scroll.columns.shift;
      if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" && data.page) {
        rows = data.page;
        indexPage = data.pageStartIndex;
      }
      var visibleWidth = width - _this.scrollbars.vertical.width;
      if (!_this.props.noVerticalScrollbar) {
        columnStartIndex = Math.max(columnStartIndex, utils.isNullOrUndefined(meta.lockedIndex) ? 0 : meta.lockedIndex + 1);
      } else {
        columnStartIndex = 0;
        columnShift = 0;
      }
      while (index < rows.length && i < height / rowHeight) {
        var row = rows[index - indexPage];
        var status = updatedRows[row.index_];
        if (meta.serverPagination && status && status.rowUpdated) {
          row = status.rowUpdated;
        }
        items.push(_this.rowRenderer(meta.table.editable, row, status, meta.properties, columnStartIndex, columnShift, visibleWidth, rowHeight, index, hasFocus, component));
        index++;
        i++;
      }
      var style = {
        top: _this.props.scroll.rows.shift || 0,
        width: visibleWidth,
        position: "inherit",
        height: "inherit"
      };
      return React.createElement(
        "div",
        { id: "content", style: style, onWheel: _this.onWheel },
        items
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Rows, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.status.loadingPage && !nextProps.noUpdate;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // console.log("row", this.focused, this.props.hasFocus);
      if (this.focused && this.focused.input && this.focused.input.ref) {
        // && this.focused.props.dataType === "boolean"
        this.focused.input.ref.focus();
        // this.focused = undefined;
        // console.log("row", this.focused);
      }
      //  else if (this.focused) {
      //   this.focused.focus();
      // }
      this.noOver = false;
    }
  }]);

  return Rows;
}(ScrollableGrid);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/Rows.js
// module id = 348
// module chunks = 0